export * from './customer';
export * from './info';
export * from './insight';
export * from './knowledgeBase';
export * from './organization';
export * from './request';
export * from './requestType';
export * from './serviceDesk';

export * as ServiceDeskModels from './models';
export * as ServiceDeskParameters from './parameters';
export * from './client';
